import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  th: {
    translation: {
      // Navigation
      nav: {
        home: "หน้าแรก",
        activities: "กิจกรรม",
        donate: "บริจาค",
        contact: "ติดต่อเรา",
        addActivity: "เพิ่มกิจกรรม",
        donors: "ผู้บริจาค",
        manageDonations: "จัดการบริจาค",
        login: "เข้าสู่ระบบ",
        logout: "ออกจากระบบ"
      },
      // Home/ActivityMap Page
      home: {
        title: "แผนที่กิจกรรม",
        mapTitle: "กิจกรรมทั้งหมดบนแผนที่",
        centerActivities: "กิจกรรมของศูนย์แบ่งต่อ",
        search: "🔍 ค้นหากิจกรรม (ชื่อ, รายละเอียด, สถานที่)",
        loading: "กำลังโหลดกิจกรรม...",
        noActivities: "ไม่มีกิจกรรม",
        viewDetails: "ดูรายละเอียด",
        location: "สถานที่",
        date: "วันที่",
        searchResults: "ผลการค้นหา"
      },
      // Activities Page
      activities: {
        title: "กิจกรรมทั้งหมด",
        noActivities: "ไม่มีกิจกรรมในขณะนี้",
        viewDetails: "ดูรายละเอียด"
      },
      // Contact Page
      contact: {
        title: "ติดต่อเรา",
        address: "ที่อยู่",
        phone: "โทรศัพท์",
        email: "อีเมล"
      },
      // Donate Page
      donate: {
        title: "ร่วมบริจาค",
        subtitle: "ขอบคุณที่ร่วมเป็นส่วนหนึ่งในการสร้างสังคมที่ดีขึ้น",
        selectType: "เลือกประเภทการบริจาค",
        money: {
          title: "บริจาคเงิน",
          description: "โอนเงินผ่านบัญชีธนาคาร",
          subtitle: "สะดวก รวดเร็ว ปลอดภัย",
          button: "เลือกบริจาคเงิน",
          header: "บริจาคเงิน",
          instruction: "โอนเงินเข้าบัญชีด้านล่างนี้",
          bank: "ธนาคาร",
          accountName: "ชื่อบัญชี",
          accountNumber: "เลขบัญชี",
          copyAccount: "คัดลอกเลขบัญชี",
          copied: "คัดลอกเลขบัญชีเรียบร้อยแล้ว!",
          note: "หมายเหตุ: หลังจากโอนเงินแล้ว กรุณาเก็บสลิปการโอนไว้เพื่อยืนยันการบริจาค"
        },
        items: {
          title: "บริจาคสิ่งของ",
          description: "บริจาคเสื้อผ้า อุปกรณ์การเรียน",
          subtitle: "และสิ่งของที่จำเป็นอื่นๆ",
          button: "เลือกบริจาคสิ่งของ",
          header: "บริจาคสิ่งของ",
          location: "สถานที่รับบริจาคสิ่งของ",
          address: "ที่อยู่",
          phone: "โทรศัพท์",
          hours: "เวลาทำการ",
          copyAddress: "คัดลอกที่อยู่",
          copiedAddress: "คัดลอกที่อยู่เรียบร้อยแล้ว!",
          parcelLabel: "ตัวอย่างการเขียนหน้าพัสดุ (กรณีส่งไปรษณีย์)",
          copyParcel: "คัดลอกข้อมูลหน้าพัสดุ",
          copiedParcel: "คัดลอกข้อมูลหน้าพัสดุเรียบร้อยแล้ว!",
          parcelHint: "คัดลอกแล้วนำไปแปะบนหน้าพัสดุได้เลย",
          acceptedItems: "สิ่งของที่รับบริจาค: เสื้อผ้า, หนังสือ, อุปกรณ์การเรียน, ของเล่น, อุปกรณ์กีฬา และสิ่งของที่อยู่ในสภาพดี",
          itemNote: "หมายเหตุ: กรุณานำส่งสิ่งของที่สะอาดและใช้งานได้จริง"
        },
        back: "← เลือกประเภทใหม่"
      },
      // Common
      common: {
        loading: "กำลังโหลด...",
        error: "เกิดข้อผิดพลาด",
        success: "สำเร็จ"
      }
    }
  },
  en: {
    translation: {
      // Navigation
      nav: {
        home: "Home",
        activities: "Activities",
        donate: "Donate",
        contact: "Contact",
        addActivity: "Add Activity",
        donors: "Donors",
        manageDonations: "Manage Donations",
        login: "Login",
        logout: "Logout"
      },
      // Home/ActivityMap Page
      home: {
        title: "Activity Map",
        mapTitle: "All Activities on Map",
        centerActivities: "Sharing Center by Mirror Foundation Activities",
        search: "🔍 Search activities (name, description, location)",
        loading: "Loading activities...",
        noActivities: "No activities",
        viewDetails: "View Details",
        location: "Location",
        date: "Date",
        searchResults: "Search Results"
      },
      // Activities Page
      activities: {
        title: "All Activities",
        noActivities: "No activities available",
        viewDetails: "View Details"
      },
      // Contact Page
      contact: {
        title: "Contact Us",
        address: "Address",
        phone: "Phone",
        email: "Email"
      },
      // Donate Page
      donate: {
        title: "Make a Donation",
        subtitle: "Thank you for being part of building a better society",
        selectType: "Select Donation Type",
        money: {
          title: "Donate Money",
          description: "Transfer via bank account",
          subtitle: "Convenient, Fast, Secure",
          button: "Choose Money Donation",
          header: "Money Donation",
          instruction: "Transfer to the account below",
          bank: "Bank",
          accountName: "Account Name",
          accountNumber: "Account Number",
          copyAccount: "Copy Account Number",
          copied: "Account number copied successfully!",
          note: "Note: After transferring, please keep the transfer slip for verification"
        },
        items: {
          title: "Donate Items",
          description: "Donate clothes, school supplies",
          subtitle: "and other essential items",
          button: "Choose Item Donation",
          header: "Item Donation",
          location: "Item Donation Center Location",
          address: "Address",
          phone: "Phone",
          hours: "Business Hours",
          copyAddress: "Copy Address",
          copiedAddress: "Address copied successfully!",
          parcelLabel: "Parcel Label Example (For Postal Delivery)",
          copyParcel: "Copy Parcel Label",
          copiedParcel: "Parcel label copied successfully!",
          parcelHint: "Copy and paste on your parcel",
          acceptedItems: "Accepted Items: Clothes, books, school supplies, toys, sports equipment, and items in good condition",
          itemNote: "Note: Please send items that are clean and usable"
        },
        back: "← Choose Another Type"
      },
      // Common
      common: {
        loading: "Loading...",
        error: "Error occurred",
        success: "Success"
      }
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'th',
    debug: false,
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
